import React from 'react';
import { Box, Container, Heading, Text, VStack } from '@chakra-ui/react';

const TermsOfServicePage = () => {
  return (
    <Container maxW="container.lg" py={10}>
      <VStack spacing={6} align="stretch">
        <Heading as="h1" size="2xl" mb={6}>Terms of Service</Heading>

        <Box>
          <Heading as="h2" size="lg" mb={4}>1. Acceptance of Terms</Heading>
          <Text mb={4}>
            By accessing and using this service, you accept and agree to be bound by the terms and provision of this agreement.
          </Text>
        </Box>

        <Box>
          <Heading as="h2" size="lg" mb={4}>2. Description of Service</Heading>
          <Text mb={4}>
            We provide a digital journaling platform with AI-powered features for personal use. The service includes:
          </Text>
          <Text as="ul" pl={5} mb={4}>
            <Text as="li">Journal entry creation and management</Text>
            <Text as="li">AI-powered analysis and insights</Text>
            <Text as="li">Data encryption and security features</Text>
            <Text as="li">Custom fields and tracking capabilities</Text>
          </Text>
        </Box>

        <Box>
          <Heading as="h2" size="lg" mb={4}>3. User Responsibilities</Heading>
          <Text mb={4}>
            You are responsible for:
          </Text>
          <Text as="ul" pl={5} mb={4}>
            <Text as="li">Maintaining the confidentiality of your account</Text>
            <Text as="li">All activities that occur under your account</Text>
            <Text as="li">Ensuring your content doesn't violate any laws</Text>
            <Text as="li">Backing up your data</Text>
            <Text as="li">Saving your recovery phrase in the event of a forgotten password</Text>
          </Text>
        </Box>

        <Box>
          <Heading as="h2" size="lg" mb={4}>4. Subscription and Payments</Heading>
          <Text mb={4}>
            Some features require a paid subscription. By subscribing to our premium service:
          </Text>
          <Text as="ul" pl={5} mb={4}>
            <Text as="li">You agree to pay the subscription fees</Text>
            <Text as="li">Subscriptions automatically renew unless cancelled</Text>
            <Text as="li">Refunds are handled according to our refund policy</Text>
          </Text>
        </Box>

        <Box>
          <Heading as="h2" size="lg" mb={4}>5. Intellectual Property</Heading>
          <Text mb={4}>
            You retain ownership of your journal entries and personal content. We retain ownership of:
          </Text>
          <Text as="ul" pl={5} mb={4}>
            <Text as="li">The service and its features</Text>
            <Text as="li">Our AI technology and algorithms</Text>
            <Text as="li">Our branding and trademarks</Text>
          </Text>
        </Box>

        <Box>
          <Heading as="h2" size="lg" mb={4}>6. Limitation of Liability</Heading>
          <Text mb={4}>
            We strive to provide a reliable service but cannot guarantee uninterrupted access. We are not liable for:
          </Text>
          <Text as="ul" pl={5} mb={4}>
            <Text as="li">Service interruptions</Text>
            <Text as="li">Data loss</Text>
            <Text as="li">Indirect or consequential damages</Text>
          </Text>
        </Box>

        <Box>
          <Heading as="h2" size="lg" mb={4}>7. Termination</Heading>
          <Text mb={4}>
            We reserve the right to terminate or suspend access to our service immediately, without prior notice or liability, for any reason whatsoever.
          </Text>
        </Box>

        <Box>
          <Heading as="h2" size="lg" mb={4}>8. Changes to Terms</Heading>
          <Text mb={4}>
            We reserve the right to modify these terms at any time. We will notify users of any changes by updating the date at the top of this agreement.
          </Text>
        </Box>

        <Box>
          <Heading as="h2" size="lg" mb={4}>9. Contact</Heading>
          <Text mb={4}>
            Questions about the Terms of Service should be sent to us through our contact form.
          </Text>
        </Box>
      </VStack>
    </Container>
  );
};

export default TermsOfServicePage; 